import BackgroundDetail from "./BackgroundDetail";

export default BackgroundDetail;
export { BackgroundDetail };
